import { importAll } from '@/utils'
export const managerTmps = {}
importAll(require.context('./', true, /\.vue$/), (key, r) => {
  const keyPath = key.match(/\.\/(.+)\.vue$/)[1]
  // console.log('managerTmps-index-keyPath',keyPath)
  // if (keyPath.includes('index')) {

  //   managerTmps[keyPath] = r(key).default ? r(key).default : r(key)
  // }
  managerTmps[keyPath] = r(key).default ? r(key).default : r(key)
})
